import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { InvitationRecord } from "../invitation.types";

export type UseFetchInvitationRecordsArgs = {
  invitationId: number;
  enabled?: boolean;
};

/**
 * Fetch invitation records for a specific invitation.
 * Returns list of records with pending/claimed status.
 */
export function useFetchInvitationRecords({
  invitationId,
  enabled = true,
}: UseFetchInvitationRecordsArgs) {
  return useQuery<InvitationRecord[]>({
    queryKey: ["invitation-records", invitationId],
    queryFn: () => apiRequest(`/invitation/${invitationId}/records/`),
    enabled: enabled && !!invitationId,
  });
}

export default useFetchInvitationRecords;

